import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleTag = (id) => {
  return useQuery({
    queryKey: ['viewTagDetails', id],
    enabled: !!id, 
    queryFn: async ({ queryKey }) => {
      const tagId = queryKey[1];   
      const res = await api.get(`/tags/show/${tagId}`);
      return res.data;
    },
  });
};